import {
  Badge,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Link,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import { DataTable } from '@pihealth/common-ui-library';
import { useEffect, useState } from 'react';
import React from 'react';
import ManualEntryDrugSupply from './ManualEntryDrugSupply';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import EditIcon from '@mui/icons-material/Edit';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import AppModal from 'src/components/modal';
import ImportCSVDrugSupply from './ImportCSVDrugSupply';
import DeleteIcon from '@mui/icons-material/Delete';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DataGridProProps, GridActionsCellItem, GridToolbarExport } from '@mui/x-data-grid-pro';
import { useAppSelector } from 'src/store';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import {
  useCreateBulkDrugSuppplyMutation,
  useDeleteSuppplyDocMutation,
  useDeleteDrugSuppplyMutation,
  useGetAllDrugSupplyMutation,
  useGetDrugSupplyMutation,
  useUpdateBulkDrugSuppplyMutation,
  useCreateDrugSuppplyDocMutation,
  useShipStatusMutation,
  useUpdateDrugSupplyStatusMutation,
  useGetAllDepotsMutation
} from 'src/services/DrugSupply';
import { setMessage } from 'src/store/Message';
import { useDispatch } from 'react-redux';
import DocumentUploadModel from 'src/components/addDocumentModel/DocumentUploadModel';
import { useGetAllDocumentsByArtifactnameStudylevelMutation } from 'src/services/etmfDocLevel';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { hideLoader, showLoader } from 'src/store/Loader';
import { useUtil } from 'src/components/hooks/useUtil';
import moment from 'moment';
import ShipDialog from './ShipDialog';
import ShippedPopup from './ShippedPopup';
import { useLazyGetSitesQuery } from 'src/services/Utils';

import {
  setConfirmSupplyData,
  setDepotsReduxData,
  setDrugSupplyRowData,
  setShippedData
} from 'src/store/drugSupplySlice';
import staticData from '../../../resources/static.json';
import RequestToShipmentDialog from './RequestToShipmentDialog';
import ShippedDialog from './ShippedDialog';

const useStyles = makeStyles(() =>
  createStyles({
    selectEntryRadioBtns: {
      '& .MuiTypography-body1': { fontSize: '16px' },
      '& .MuiTypography-body2': { fontSize: '14px', color: 'rgba(0,0,0,0.6)' }
    },
    LotlabelinRow: {
      position: 'absolute',
      top: '-11px',
      left: '76px',
      padding: '0px 6px',
      background: '#2196F3',
      color: 'white',
      fontSize: '10px',
      fontWeight: 'bold',
      borderRadius: '0 0 4px 4px',
      textTransform: 'none'
    }
  })
);

const DrugSupply = () => {
  const [rows, setRows] = useState([]);
  const [addDrugSupplyPopup, setAddDrugSupplyPopup] = useState(false);
  const [entryMethodValue, setEntryMethodValue] = useState('');
  const [manualEntryPopup, setManualEntryPopup] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [filterObject, setFilterObject] = useState<any>({});
  const selectedStudy: any = useAppSelector(state => state.site.selectedStudy);
  const [importCSVPopup, setImportCSVPopup] = useState(false);
  const [CSVRecords, setCSVRecords] = useState(null);
  const { data: codeListData } = useGetCodeListDataQuery('IPSSTAT');
  const dispatch = useDispatch();
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const { checkPermission } = usePermissionWrapper();
  const [uploadDocDialogOpen, setUploadDocDilogOpen] = useState(false);
  const [selectedRecordId, setSelectedRecordId] = useState('');
  const [attachedDocsList, setAttachedDocsList] = useState<any[]>([]);
  const { handleError, dataDetailsCreation, showSuccess } = useUtil();
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [rowsCount, setRowsCount] = useState(0);
  const [openShipPopup, setOpenShipPopup] = useState(false);
  const [openShippedPopup, setOpenShippedPopup] = useState(false);
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const [openRequestShipment, setOpenRequestShipment] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [openShipped, setOpenShipped] = useState<boolean>(false);
  const [approvalData, setApprovalData] = useState(staticData.approvalData);
  const [approveDialog, setApproveDialog] = useState(false);
  const [approvalSubmitData, setApprovalSubmitData] = useState<any>({});
  const [sites, setSites] = useState<any>([]);
  const [getSiteData] = useLazyGetSitesQuery();
  const [selectedRowData, setSelectedRowData] = useState<any>({});
  const [statusData, setStatusData] = useState({});
  const [customMessage, setCustomMessage] = useState('Add drug supply to populate table');
  const [
    getAllDrugSupply,
    {
      data: DrugSupplyData,
      isSuccess: allDrugSupplyDataIsSuccess,
      isError: allDrugSupplyDataIsError,
      error: allDrugSupplyDataError,
      isLoading: allDrugSupplyDataLoading
    }
  ] = useGetAllDrugSupplyMutation();
  const [deleteDrugSupply, { isSuccess: deleteDrugSupplyIsSuccess }] = useDeleteDrugSuppplyMutation();
  const setCustomeMessageByFilterObject = (rowsObj: any[]) => {
    if (
      rowsObj.length === 0 &&
      !(
        filterObject &&
        Object.prototype.hasOwnProperty.call(filterObject, 'filters') &&
        filterObject.filters.map((filter: any) => filter.value !== '').some((value: boolean) => value)
      )
    ) {
      setCustomMessage('Add drug supply to populate table');
    } else {
      setCustomMessage('No results found.');
    }
  };
  useEffect(() => {
    setCustomeMessageByFilterObject([]);
    setRows([]);
    getAllDepots({
      study_id: selectedStudy,
      application: 'SYSADMIN',
      application_section: 'SYSADMIN',
      application_module_section: 'Master List of Studies'
    });
    getAllDrugSupply({
      study_id: selectedStudy,
      application: process.env.REACT_APP_NAME,
      application_section: process.env.REACT_APP_TUDA_SLUG,
      application_module_section: process.env.REACT_APP_CONDUCT_NAME,
      data: { ...filterObject },
      from: 0,
      size: pageSize,
      is_country_based_data: !checkPermission(`country_sponsor_supply`),
      is_received_data: checkPermission('mark_as_received') || checkPermission(`ship_drug_supply`)
    });
  }, [selectedStudy]);
  const [
    CreateBulkDrugSuppplyQuery,
    {
      isSuccess: CreateBulkDrugSuppplyQuerySuccess,
      isError: CreateBulkDrugSuppplyQueryIsError,
      error: CreateBulkDrugSuppplyQueryError
    }
  ] = useCreateBulkDrugSuppplyMutation();

  const [UpdateBulkDrugSuppplyQuery, { isSuccess: UpdateBulkDrugSuppplyQuerySuccess }] =
    useUpdateBulkDrugSuppplyMutation();

  const [getDrugSupply, { data: drugSupplyData, isSuccess: drugSupplyDataIsSuccess }] = useGetDrugSupplyMutation();
  const [createDrugSupplyDoc, { isSuccess: createDrugSupplyDocSuccess }] = useCreateDrugSuppplyDocMutation();
  const [deleteDrugSupplyDoc, { isSuccess: deleteDrugSupplyDocSuccess }] = useDeleteSuppplyDocMutation();
  const [shipStatus, { isLoading: shipStatusIsLoading }] = useShipStatusMutation();
  const [getAllDepots, { data: depotsData, isError: depotsDataIsError, error: deportDataError }] =
    useGetAllDepotsMutation();
  const [getDocsByArtifactNameStudyLevel] = useGetAllDocumentsByArtifactnameStudylevelMutation();
  useEffect(() => {
    if (depotsDataIsError) {
      const err: any = deportDataError;
      handleError(err);
    }
  }, [depotsDataIsError]);
  useEffect(() => {
    if (depotsData) {
      dispatch(setDepotsReduxData(depotsData));
    }
  }, [depotsData]);
  const getRowsData = () => {
    if (!allDrugSupplyDataLoading && (pageSize === 10 || pageSize === 20 || pageSize === 30)) {
      const optionsObj = {
        study_id: selectedStudy,
        application: process.env.REACT_APP_NAME,
        application_section: process.env.REACT_APP_TUDA_SLUG,
        application_module_section: process.env.REACT_APP_CONDUCT_NAME,
        data: { ...filterObject },
        from: 0,
        size: pageSize,
        is_country_based_data: !checkPermission(`country_sponsor_supply`),
        is_received_data: checkPermission('mark_as_received') || checkPermission(`ship_drug_supply`)
      };
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAllDrugSupply(optionsObj);
      } else {
        getAllDrugSupply({ ...optionsObj, from: pageNumber * pageSize });
      }
    }
  };
  useEffect(() => {
    getRowsData();
  }, [pageNumber, pageSize, filterObject]);

  useEffect(() => {
    if (createDrugSupplyDocSuccess) {
      getRowsData();
      dispatch(setMessage({ msgDetails: 'Document uploaded successfully.', severity: 'success' }));
    }
  }, [createDrugSupplyDocSuccess]);

  useEffect(() => {
    if (deleteDrugSupplyDocSuccess) {
      getRowsData();
      dispatch(setMessage({ msgDetails: 'Document deleted successfully.', severity: 'success' }));
    }
  }, [deleteDrugSupplyDocSuccess]);
  useEffect(() => {
    if (CreateBulkDrugSuppplyQuerySuccess) {
      getRowsData();
      dispatch(
        setMessage({ msgDetails: 'Drug supply is added successfully and sent for review', severity: 'success' })
      );
    }
  }, [CreateBulkDrugSuppplyQuerySuccess]);
  useEffect(() => {
    if (deleteDrugSupplyIsSuccess) {
      getRowsData();
      dispatch(setMessage({ msgDetails: 'The drug supply record has been deleted successfully', severity: 'success' }));
    }
  }, [deleteDrugSupplyIsSuccess]);
  useEffect(() => {
    if (UpdateBulkDrugSuppplyQuerySuccess) {
      getRowsData();
      dispatch(setMessage({ msgDetails: 'The drug supply record has been updated successfully', severity: 'success' }));
    }
  }, [UpdateBulkDrugSuppplyQuerySuccess]);

  useEffect(() => {
    if (allDrugSupplyDataIsSuccess) {
      const formattedRows =
        DrugSupplyData?.selected_data &&
        DrugSupplyData?.selected_data.map((row: any) => {
          return {
            ...row.drug_supply_data,
            drug_supply_file_data: row.drug_supply_file_data,
            earliest_expiration_date: preferedDateFormat(row?.drug_supply_data?.earliest_expiration_date),
            latest_expiration_date: preferedDateFormat(row?.drug_supply_data?.latest_expiration_date)
          };
        });
      setCustomeMessageByFilterObject(formattedRows);
      setRows(formattedRows);
      setRowsCount(DrugSupplyData.record_count);
    }
  }, [allDrugSupplyDataIsSuccess, userPreferedDateFormat]);
  useEffect(() => {
    if (allDrugSupplyDataIsError || CreateBulkDrugSuppplyQueryIsError) {
      if (allDrugSupplyDataIsError) {
        setRows([]);
        setRowsCount(0);
      }
      const err: any = allDrugSupplyDataError || CreateBulkDrugSuppplyQueryError;
      handleError(err);
    }
  }, [allDrugSupplyDataIsError, CreateBulkDrugSuppplyQueryIsError]);

  const [
    updateDStatusFunc,
    { isSuccess: updateDStatusIsSuccess, isError: updateDStatusIsError, error: updateDStatusError }
  ] = useUpdateDrugSupplyStatusMutation();

  useEffect(() => {
    if (updateDStatusIsSuccess) {
      showSuccess('Drug supply successfully Approved');
      getRowsData();
    } else if (updateDStatusIsError) {
      handleError(updateDStatusError, true);
    }
  }, [updateDStatusIsSuccess]);

  const handleApproveSubmit = () => {
    updateDStatusFunc({
      drug_supply_id: approvalSubmitData?.id,
      study_id: selectedStudy,
      application: process.env.REACT_APP_NAME,
      application_section: process.env.REACT_APP_TUDA_SLUG,
      application_module_section: process.env.REACT_APP_CONDUCT_NAME,
      data: {
        status: 'Available'
      }
    });
    setApproveDialog(false);
  };

  const handleDeleteClick = (id: any, rowData: any) => () => {
    if (rowData?.status === 'Shipped') {
      dispatch(
        setMessage({ msgDetails: "Drug supply record can not be deleted with the status 'SHIPPED'", severity: 'info' })
      );
    } else if (rowData?.shipment_id) {
      dispatch(
        setMessage({
          msgDetails: 'Drug supply that is available for shipment to the site cannot be deleted',
          severity: 'info'
        })
      );
    } else {
      setDeletePopup(true);
      setDeleteId(id);
    }
  };
  const handleClickRequestShipment = (data: any) => {
    setOpenRequestShipment(true);
    dispatch(setDrugSupplyRowData(data));
  };
  const handleClickConfirm = (data: any) => {
    setOpenConfirm(true);
    dispatch(
      setConfirmSupplyData({
        ...data,
        transfer_quantity: data?.transfer_quantity,
        transfer_from: `${data?.depot_name} - ${data?.depot_id}`,
        quantity: data?.quantity
      })
    );
  };
  const handleClickShipped = (data: any) => {
    setOpenShipped(true);
    dispatch(
      setShippedData({
        ...data,
        transfer_quantity: data?.transfer_quantity,
        transfer_from: `${data?.depot_name} - ${data?.depot_id}`
      })
    );
  };
  const handleApprove = (data: any) => {
    setApprovalData(dataDetailsCreation(staticData.approvalData, data, null, userPreferedDateFormat));
    setApprovalSubmitData(data);
    setApproveDialog(true);
  };

  const getWorkflowButtonFunc = (rowData: any) => {
    switch (rowData?.status) {
      case 'Shipped':
        return (
          <>
            <Typography variant="body1">Shipment ID:&nbsp;</Typography>
            <Typography variant="body1">{rowData?.shipment_id}</Typography>
          </>
        );
      case 'Shipment Requested':
        if (checkPermission(`confirm_drug_supply`)) {
          return (
            <Button
              size="small"
              variant="contained"
              disabled={!checkPermission(`confirm_drug_supply`)}
              onClick={() => handleClickConfirm(rowData)}
            >
              Confirm
            </Button>
          );
        }
        return (
          <Button size="small" disabled variant="contained">
            Ship
          </Button>
        );
      case 'Available':
        if (!rowData?.shipment_id) {
          return (
            <Button
              disabled={!checkPermission(`request_to_ship_drug_supply`)}
              variant="contained"
              onClick={() => handleClickRequestShipment(rowData)}
              size="small"
            >
              Request To Ship
            </Button>
          );
        } else if (checkPermission(`ship_drug_supply`) && rowData?.shipment_id) {
          return (
            <Button
              variant="contained"
              onClick={() => handleShipBtn(rowData)}
              size="small"
              disabled={!checkPermission(`ship_drug_supply`) || !rowData.quantity}
            >
              <span className={classes.LotlabelinRow}>Lot #: {rowData?.manufacturing_lot}</span>
              Ship
            </Button>
          );
        }
        break;
      case 'Review Pending':
        if (checkPermission(`approve_drug_supply`)) {
          return (
            <Button size="small" variant="contained" onClick={() => handleApprove(rowData)}>
              Approve
            </Button>
          );
        }
        return (
          <Button size="small" disabled variant="contained">
            Ship
          </Button>
        );
      default:
        return (
          <Button size="small" disabled variant="contained">
            Ship
          </Button>
        );
    }
  };

  const classes = useStyles();

  const handleClickStatusLink = (rowData: any) => {
    return rowData.status === 'Shipped' ? (
      <Link onClick={() => handleClickShipped(rowData)}>{rowData.status}</Link>
    ) : (
      rowData.status
    );
  };

  const handleShipBtn = async (data: any) => {
    setSelectedRowData(data);
    setOpenShipPopup(true);
    const tempSites: any = await getSiteData({ currentStudy: selectedStudy, currentCountry: data.depot_country });
    if (tempSites.data) {
      setSites([...new Set(tempSites.data?.map((ele: any) => ele.name))]);
    }
  };

  const drugSupplyColumns = [
    {
      field: 'Supply',
      headerName: '',
      minWidth: 180,
      flex: 1,
      filterable: false,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      renderCell: (params: any) => getWorkflowButtonFunc(params.row)
    },
    {
      field: 'depot_name',
      headerName: 'Depot Name',
      minWidth: 140,
      flex: 1
    },
    {
      field: 'depot_country',
      headerName: 'Depot Country',
      minWidth: 140,
      flex: 1
    },
    {
      field: 'depot_id',
      headerName: 'Depot ID',
      minWidth: 180,
      flex: 1
    },
    {
      field: 'custom_name',
      headerName: 'Custom Name',
      minWidth: 140,
      flex: 1
    },
    {
      field: 'cost_per_unit',
      headerName: 'Cost Per Unit',
      width: 100
    },
    {
      field: 'investigational_drug',
      headerName: 'Investigational Drug',
      minWidth: 140,
      flex: 1
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      description: 'Quantity available at this Depot',
      width: 80,
      type: 'number',
      valueFormatter: (params: any) => {
        return params.value;
      }
    },
    {
      field: 'quantity_retained',
      headerName: 'Quantity Retained',
      description: 'Quantity withheld at this Depot',
      width: 140,
      type: 'number',
      defaultValue: 0,
      valueFormatter: (params: any) => {
        return params.value;
      }
    },
    {
      field: checkPermission(`ship_drug_supply`) ? 'total_shipped_quantity' : 'transfer_quantity',
      headerName: checkPermission(`ship_drug_supply`) ? 'Total Shipped Quantity' : 'Transfer Quantity',
      description: checkPermission(`ship_drug_supply`)
        ? 'Quantity of Drug being Shipped from this Depot'
        : 'Quantity of Drug being transferred from this Depot',
      width: 140,
      type: 'number',
      defaultValue: 0,
      valueFormatter: (params: any) => {
        return params.value;
      }
    },
    {
      field: 'dose',
      headerName: 'Dose',
      width: 90,
      type: 'number'
    },
    {
      field: 'dose_unit',
      headerName: 'Dose Unit',
      width: 100
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 160,
      type: 'singleSelect',
      renderCell: (params: any) => handleClickStatusLink(params.row),
      valueOptions: codeListData?.map((item: any) => item?.code_list_value)
    },
    {
      field: 'manufacturer',
      headerName: 'Manufacturer',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'manufacturing_lot',
      headerName: 'Manufacturing Lot #',
      minWidth: 140,
      flex: 1
    },
    {
      field: 'packaging_lot',
      headerName: 'Packaging Lot #',
      minWidth: 140,
      flex: 1
    },
    {
      field: 'earliest_expiration_date',
      headerName: 'Earliest Expiration Date',
      minWidth: 150,
      flex: 1,
      type: 'date'
    },
    {
      field: 'latest_expiration_date',
      headerName: 'Latest Expiration Date',
      minWidth: 150,
      flex: 1,
      type: 'date'
    },
    {
      field: 'number_of_kits',
      headerName: 'Number of Kits',
      width: 120,
      valueFormatter: (params: any) => {
        return params.value;
      }
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      filterable: false,
      disableExport: true,
      renderCell: (params: any) => {
        const id = params.id;
        return [
          <GridActionsCellItem
            icon={
              params.row.status === 'Shipped' ? (
                <Tooltip title="Drug supply record can not be edited with the status 'SHIPPED'">
                  <EditIcon />
                </Tooltip>
              ) : (
                <EditIcon />
              )
            }
            label="Edit"
            disabled={!checkPermission('manage_drug_supply')}
            sx={{
              color: 'primary.main',
              fontSize: '1.5rem'
            }}
            onClick={handleEditClick(id, params.row)}
            key={id}
          />,
          <GridActionsCellItem
            icon={
              params.row.drug_supply_file_data && params.row.drug_supply_file_data.length > 0 ? (
                <Badge
                  badgeContent={params.row.drug_supply_file_data.length}
                  color="primary"
                  className="smallBadgeSearch"
                >
                  {' '}
                  <AttachFileIcon />{' '}
                </Badge>
              ) : (
                <AttachFileIcon />
              )
            }
            label="Attach"
            className="textPrimary"
            onClick={() => handleAttachClick(id, params.row.drug_supply_file_data)}
            key={2}
            sx={{
              color: 'primary.main'
            }}
            color="inherit"
            disabled={!checkPermission('view_drug_supply')}
          />,
          <GridActionsCellItem
            key={id}
            icon={
              params.row.status === 'Shipped' ? (
                <Tooltip title="Drug supply record can not be deleted with the status 'SHIPPED'">
                  <DeleteIcon />
                </Tooltip>
              ) : (
                <DeleteIcon />
              )
            }
            label="Delete"
            disabled={!checkPermission('manage_drug_supply')}
            onClick={handleDeleteClick(id, params.row)}
            sx={{
              color: 'primary.main',
              fontSize: '1.5rem'
            }}
          />
        ];
      }
    }
  ];

  const popupOptions = [
    {
      header: 'Import CSV',
      description: 'Import CSV to populate table',
      key: 'import_csv'
    },
    {
      header: 'Manual Entry',
      description: 'Enter values directly into the system',
      key: 'manual_entry'
    }
  ];
  const columns = [
    {
      field: 'shipment_id',
      headerName: 'Shipment ID',
      minWidth: 150,
      flex: 1
    },
    {
      field: 'quantity_shipped',
      headerName: 'Quantity Shipped',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 100,
      flex: 1,
      renderCell: (params: any) => <Link onClick={() => handleShippedStatus(params.row)}>{params.row.status}</Link>
    },
    {
      field: 'site_id',
      headerName: 'Site ID',
      minWidth: 180,
      flex: 1
    }
  ];

  const handleEditClick = (id: any, rowData: any) => () => {
    if (rowData?.status === 'Shipped') {
      dispatch(
        setMessage({ msgDetails: "Drug supply record can not be edited with the status 'SHIPPED'", severity: 'info' })
      );
    } else {
      setIsEdit(true);
      getDrugSupply({
        study_id: selectedStudy,
        drug_supply_id: id,
        application: process.env.REACT_APP_NAME,
        application_section: process.env.REACT_APP_TUDA_SLUG,
        application_module_section: process.env.REACT_APP_CONDUCT_NAME
      });
      setManualEntryPopup(true);
    }
  };

  const addDrunSupply = () => {
    setAddDrugSupplyPopup(true);
  };

  const entryMethodChange = (e: any) => {
    setEntryMethodValue(e.target.value);
  };

  const confirmEntryMethod = () => {
    if (entryMethodValue == 'manual_entry') {
      setManualEntryPopup(true);
    }
    if (entryMethodValue === 'import_csv') {
      setImportCSVPopup(true);
    }
    setAddDrugSupplyPopup(false);
    setEntryMethodValue('');
  };

  const filterValues = (data: any) => {
    setFilterObject(data);
  };
  const handleAttachClick = async (recordId: string, filesAttached: any[]) => {
    dispatch(showLoader());
    const tmfDocIdsList = filesAttached.length ? filesAttached.map((file: any) => file.tmf_document_id) : [];
    if (tmfDocIdsList.length) {
      const docsListResponse: any = await getDocsByArtifactNameStudyLevel({
        data: {
          filters: [
            {
              name: 'tmf_document_id',
              value: tmfDocIdsList,
              operation: 'in'
            }
          ],
          type: 'AND'
        },
        docLevel: 'Study',
        study_id: selectedStudy,
        application: process.env.REACT_APP_NAME,
        module_section_related: process.env.REACT_APP_NAME,
        parent_entity_related: ''
      });
      if (docsListResponse?.data) {
        setAttachedDocsList(docsListResponse?.data?.selected_data);
      } else if (docsListResponse?.error && docsListResponse?.error.status !== 404) {
        setAttachedDocsList([]);
        dispatch(setMessage({ msgDetails: 'Error getting list of documents attached', severity: 'error' }));
      }
    } else {
      setAttachedDocsList([]);
    }
    setUploadDocDilogOpen(true);
    setSelectedRecordId(recordId);
    dispatch(hideLoader());
  };

  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Drug Supply ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };

  const dataTableProps = {
    filterMode: 'server'
  };
  const getDetailPanelContent = React.useCallback<NonNullable<DataGridProProps['getDetailPanelContent']>>(
    ({ row }) => <DetailPanelContent row={row} />,
    []
  );

  const getDetailPanelHeight = React.useCallback(() => 400, []);

  function DetailPanelContent({ row: rowProp }: { row: any }) {
    const [panelData, setPanelData] = useState([]);
    const [panelLoading, setPanelLoading] = useState(false);

    const getData = async () => {
      setPanelLoading(true);
      const tempRowData: any = await shipStatus({
        study_id: selectedStudy,
        drug_supply_id: rowProp?.id,
        application: process.env.REACT_APP_NAME,
        application_section: process.env.REACT_APP_TUDA_SLUG,
        application_module_section: process.env.REACT_APP_CONDUCT_NAME
      });
      if (tempRowData.data) {
        const temp: any = tempRowData.data.map((ele: any) => {
          return {
            ...rowProp,
            ...ele,
            status: `Shipped`
          };
        });
        setPanelData(temp);
        setPanelLoading(false);
      } else {
        setPanelData([]);
        setPanelLoading(false);
      }
    };
    useEffect(() => {
      getData();
    }, []);

    return (
      <Stack
        sx={{ py: 2, height: '100%', boxSizing: 'border-box', borderTop: '1px solid rgba(0,0,0,0.12)' }}
        direction="column"
      >
        <Paper sx={{ flex: 1, ml: 12, maxWidth: '700px', p: 1 }}>
          <DataTable
            rows={panelData || []}
            columns={columns}
            loading={shipStatusIsLoading || panelLoading}
            showMUIFeature={false}
            hasDefinedColumns
            hideFooterPagination
            hideGridToolbar
            pagination={false}
            hideFooter
            hideFooterRowCount
            hideFooterSelectedRowCount
            height="30vh"
          />
        </Paper>
      </Stack>
    );
  }

  const handleShippedStatus = (data: any) => {
    setOpenShippedPopup(true);
    setStatusData(data);
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button
          variant="contained"
          onClick={addDrunSupply}
          sx={{ mt: -2 }}
          disabled={!checkPermission('manage_drug_supply') || !selectedStudy}
        >
          Add Drug Supply
        </Button>
      </Box>
      <DataTable
        sx={{
          '&.MuiDataGrid-root--densityCompact  .LotlabelinRow': { top: '0px' },
          '&.MuiDataGrid-root--densityStandard  .LotlabelinRow': { top: '-11px' },
          '&.MuiDataGrid-root--densityComfortable  .LotlabelinRow': { top: '-19px' }
        }}
        height="76vh"
        rows={rows || []}
        columns={drugSupplyColumns}
        customeMessage={
          <Stack height="80%" alignItems="center" justifyContent="center">
            {customMessage}
          </Stack>
        }
        pinnedColumns={{ right: ['actions'] }}
        exportCSVName={'Drug Supply'}
        hasDefinedColumns
        filterValues={(data: any) => filterValues(data)}
        loading={allDrugSupplyDataLoading}
        setPageSize={setPageSize}
        paging
        rowsCount={rowsCount}
        pageNumber={pageNumber}
        pageSize={pageSize}
        setPageNumber={setPageNumber}
        paginationMode="server"
        hasDefinedDataGridToolbarExport
        definedGridToolbarExport={definedCustomDatGridExport}
        dataTableProps={dataTableProps}
        getDetailPanelHeight={getDetailPanelHeight}
        getDetailPanelContent={checkPermission(`ship_drug_supply`) ? getDetailPanelContent : undefined}
      />
      <AppModal
        open={addDrugSupplyPopup}
        title={'Select Method of Entry'}
        handleSubmit={confirmEntryMethod}
        handleClose={() => {
          setAddDrugSupplyPopup(false);
          setEntryMethodValue('');
        }}
        closeButton="Cancel"
        saveButton="Confirm"
        disabled={!entryMethodValue}
        outSideClickClose
        maxWidth={480}
      >
        <FormControl sx={{ width: '100%' }} className={classes.selectEntryRadioBtns}>
          <RadioGroup name="drug-supply-entry-method" value={entryMethodValue} onChange={entryMethodChange}>
            {popupOptions.map((item: any) => (
              <Paper
                elevation={1}
                square={false}
                key={item.key}
                sx={{
                  py: 2,
                  pl: 1,
                  pr: 3,
                  my: 1.5,
                  border: '1px solid rgba(0,0,0,0.12)',
                  '& .MuiFormControlLabel-root': { width: '100%', justifyContent: 'space-between' }
                }}
              >
                <FormControlLabel
                  value={item.key}
                  key={item.key}
                  control={<Radio />}
                  label={
                    <>
                      <Typography variant="body1" gutterBottom>
                        {item.header}
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        {item.description}
                      </Typography>
                    </>
                  }
                  labelPlacement="start"
                />
              </Paper>
            ))}
          </RadioGroup>
        </FormControl>
      </AppModal>
      <ImportCSVDrugSupply
        importCSVPopup={importCSVPopup}
        setImportCSVPopup={setImportCSVPopup}
        setCSVRecords={setCSVRecords}
        setManualEntryPopup={setManualEntryPopup}
      />
      <AppModal
        open={deletePopup}
        title={'Confirm'}
        handleClose={() => {
          setDeletePopup(false);
        }}
        handleSubmit={() => {
          setDeletePopup(false);
          deleteDrugSupply({
            study_id: selectedStudy,
            drug_supply_id: deleteId,
            application: 'CTMS',
            application_section: process.env.REACT_APP_TUDA_SLUG,
            application_module_section: process.env.REACT_APP_CONDUCT_NAME
          });
        }}
        saveButton={'Confirm'}
        closeButton={'Cancel'}
        child
      >
        <Box pb={1.5}>{`Are you sure you want to delete the Drug Supply record.`}</Box>
      </AppModal>
      <AppModal
        open={approveDialog}
        title={'Approve'}
        handleClose={() => setApproveDialog(false)}
        handleSubmit={handleApproveSubmit}
        saveButton={'Approve'}
        closeButton={'Cancel'}
        maxWidth="600px"
      >
        <Box
          mb={2}
          sx={{ wordBreak: 'break-word', '#modal-title:has(.MuiTypography-subtitle1)': { borderRadius: '0' } }}
        >
          <Box py={1.5}>
            <Typography variant="body1" gutterBottom>
              {`Please review all the information for this drug item. Approving will make this item available for shipment.`}
            </Typography>
          </Box>
          <Grid container spacing={2} columnSpacing={4}>
            {approvalData.map((data: any, index: number) => (
              <Grid item md={6} key={`approvalData${index}`}>
                <Typography variant="body1">
                  <strong>{data.key ? `${data.key}:` : ``}</strong> {data.value}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
      </AppModal>

      <ManualEntryDrugSupply
        setManualEntryPopup={setManualEntryPopup}
        manualEntryPopup={manualEntryPopup}
        CreateBulkDrugSuppplyQuery={CreateBulkDrugSuppplyQuery}
        drugSupplyDataIsSuccess={drugSupplyDataIsSuccess}
        drugSupplyData={drugSupplyData}
        CSVRecords={CSVRecords}
        setCSVRecords={setCSVRecords}
        isEdit={isEdit}
        UpdateBulkDrugSuppplyQuery={UpdateBulkDrugSuppplyQuery}
        setIsEdit={setIsEdit}
      />
      <DocumentUploadModel
        uploadDocDialogOpen={uploadDocDialogOpen}
        setUploadDocDilogOpen={setUploadDocDilogOpen}
        moduleSection={process.env.REACT_APP_CONDUCT_NAME || ''}
        createDrugSupplyDoc={createDrugSupplyDoc}
        deleteDrugSupplyDoc={deleteDrugSupplyDoc}
        selectedRecordId={selectedRecordId}
        attachedDocumentsList={attachedDocsList}
        setAttachedDocsList={setAttachedDocsList}
      />
      {openShipPopup && (
        <ShipDialog
          openShipPopup={openShipPopup}
          setOpenShipPopup={setOpenShipPopup}
          sites={sites}
          selectedRowData={selectedRowData}
          setSelectedRowData={setSelectedRowData}
          getRowsData={getRowsData}
        />
      )}
      <ShippedPopup
        openShippedPopup={openShippedPopup}
        setOpenShippedPopup={setOpenShippedPopup}
        selectedRowData={selectedRowData}
        statusData={statusData}
        setStatusData={setStatusData}
      />
      {(openRequestShipment || openConfirm) && (
        <RequestToShipmentDialog
          openRequestShipment={openRequestShipment}
          setOpenRequestShipment={setOpenRequestShipment}
          openConfirm={openConfirm}
          setOpenConfirm={setOpenConfirm}
          getRowsData={getRowsData}
        />
      )}
      {openShipped && <ShippedDialog openShipped={openShipped} setOpenShipped={setOpenShipped} />}
    </>
  );
};

export default DrugSupply;
